import React, { useEffect, useRef } from "react";
import Message from "./Message";
import TypingIndicator from "./TypingIndicator";
import { userAvatar } from "../data/messages";
import { profils } from "../data/profils";
import { getProfilIdFromUrlName } from "../utils/chatProfileUtils";

const ChatContainer = ({ messages, isTyping }) => {
  const chatContainerRef = useRef(null);

  // Détermine le profil courant selon l'URL
  const profilId = getProfilIdFromUrlName();
  const profil = profils[profilId] || profils[1];

  // Fonction pour scroller vers le bas
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  // Scroller automatiquement quand les messages ou l'état de frappe changent
  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  return (
    <div
      ref={chatContainerRef}
      className="chat-container overflow-y-auto p-4 flex flex-col space-y-4 pb-24 scrollbar-hidden"
    >
      {messages.map((msg, index) => (
        <Message
          key={index}
          message={{
            ...msg,
            avatar: msg.isUser
              ? userAvatar
              : profil.avatar,
          }}
          isUser={msg.isUser}
        />
      ))}
      {isTyping && <TypingIndicator avatar={profil.avatar} />}
    </div>
  );
};

export default ChatContainer;
